import type { TFunction } from "i18next"
import { humanizeField } from "./humanize"

const MESSAGE_TRANSLATIONS: Record<string, string> = {
    "can't be blank": "errors.messages.blank",
    "must exist": "errors.messages.mustExist",
    "is invalid": "errors.messages.invalid",
    "has already been taken": "errors.messages.taken",
    "is not a number": "errors.messages.notANumber",
    "is too short": "errors.messages.tooShort",
    "is too long": "errors.messages.tooLong",
    "must be greater than 0": "errors.messages.greaterThan",
    "must be greater than or equal to 0": "errors.messages.greaterThan",
}

function translateMessage(t: TFunction, message: string): string {
    const key = MESSAGE_TRANSLATIONS[message]
    if (!key) return message
    return t(key, { defaultValue: message })
}

export function translateErrorMessage(
    t: TFunction,
    messages: string[] | undefined,
): string | undefined {
    const first = messages?.[0]
    if (!first) return undefined
    return translateMessage(t, first)
}

function translateSegment(t: TFunction, segment: string): string {
    const localized = t(`errors.fields.${segment}`, { defaultValue: "" })
    if (localized) return localized
    return humanizeField(t, undefined, segment)
}

function translateFieldPath(t: TFunction, fieldPath: string): string {
    return fieldPath
        .split(".")
        .map(s => translateSegment(t, s))
        .join(" › ")
}

export function formatErrorMessages(
    t: TFunction,
    errors: Record<string, string[]> | undefined,
): string[] {
    if (!errors) return []
    const seen = new Set<string>()
    const out: string[] = []
    for (const [field, messages] of Object.entries(errors)) {
        const label = translateFieldPath(t, field)
        for (const msg of messages) {
            const text = `${label} ${translateMessage(t, msg)}`
            if (!seen.has(text)) {
                seen.add(text)
                out.push(text)
            }
        }
    }
    return out
}
